/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import {
  CanvasRenderer
  // SVGRenderer,
} from 'echarts/renderers';
echarts.use([TooltipComponent, PieChart, CanvasRenderer]);
import styled from '@emotion/styled';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { hrmsPaths } from 'constants/pagePath';
import FeatherIcon from 'feather-icons-react';

const CustomAlert = styled(Alert)`
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 400;
  font-size: 0.875rem;
  display: flex;
  padding: 6px 16px;
`;

const IconBox = styled('div')`
  margin-right: 6px;
  padding: 7px 0px;
  display: flex;
  font-size: 22px;
  opacity: 0.9;
  display: 'flex';
  align-items: center;
`;
const getDefaultOptions = (getThemeColor, countData) => ({
  color: [getThemeColor('warning'), getThemeColor('secondary')],

  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getThemeColor('warning-100'),
    borderColor: getThemeColor('warning-100'),
    textStyle: { color: getThemeColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: params => `<strong>${params.name}:</strong> ${params.percent}%`
  },
  legend: { show: false },
  series: [
    {
      name: `${countData.totalPercent} %`,
      type: 'pie',
      radius: ['100%', '87%'],
      avoidLabelOverlap: false,
      emphasis: {
        scale: false,
        itemStyle: {
          color: 'inherit'
        }
      },
      itemStyle: {
        borderWidth: 0,
        borderColor: getThemeColor('white')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 10,
        color: getThemeColor('dark')
      },
      data: [
        { value: countData.totalPercent, name: 'Complete' },
        { value: countData.remainingPercent, name: 'Pending' }
      ]
    }
  ],
  grid: { containLabel: true }
});
const IncompleteDetailAlert = ({
  percentage,
  driver_id,
  data,
  onCompleteNow,
  isManualUpdate
}) => {
  console.log('🚀 ~ data:today', data);
  const { getThemeColor } = useAppContext();
  const flag = data?.change_flag == 1 || isManualUpdate;
  return (
    <div className="w-100 px-3">
      <CustomAlert className="bg-warning-100 border px-3 py-2 border-warning text-warning w-100 flex-column">
        <div className="d-flex flex-column flex-sm-row">
          <FeatherIcon
            icon="alert-triangle"
            className="text-warning me-2 mt-1"
            size={24}
          />
          <div className="py-1 fs-9 w-100">
            <p className="fs-8 fw-bold mb-0 mb-2 fs-8 fw-medium">
              {flag
                ? 'Trucker Approval Is Pending'
                : 'Trucker Data is incomplete'}
            </p>
            <small className="fs-9 fw-normal lh-base">
              <b>Attention: </b>
              {flag
                ? 'Your approval request is currently under review.'
                : 'It appears that some required information is missing. Please complete all sections to ensure Trucker details are up to date.'}
            </small>
          </div>
        </div>
        <div className="w-100 mt-2 ps-md-4">
          <Button
            className="font-outfit p-2 px-3 fs-9"
            variant="warning"
            onClick={onCompleteNow}
            disabled={flag == 1}
          >
            Complete Now
          </Button>
        </div>
      </CustomAlert>
    </div>
  );
};

export default IncompleteDetailAlert;
